/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import styled from "styled-components";
import Main from "./components/main/Main";
import { createWeb3Modal } from '@web3modal/wagmi/react'
import { defaultWagmiConfig } from '@web3modal/wagmi/react/config'
import { WagmiProvider } from 'wagmi'
import {
  arbitrum, base, avalanche, bsc,
  mainnet, optimism, polygon, fantom,
  zkSync, opBNB, dogechain, sei
} from 'wagmi/chains'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import {
  getDefaultConfig,
  RainbowKitProvider,
  DisclaimerComponent,
  darkTheme
} from '@rainbow-me/rainbowkit';
import '@rainbow-me/rainbowkit/styles.css';

import Home from './pages/Home/Home';

import './App.css';
import ApplyLaunch from "pages/ApplytoLaunch";
import IncubatorPage from "pages/Incubator";
import { LaunchPoolNew } from "pages/LaunchPool";
import StakePoolV2 from "pages/LauchPool-v2";
import { APPLY, HOME, ICUBATOR, LAUNCHPOOL_DETAIL_URL, LAUNCHPOOL_URL } from "components/constants";


const projectId = '90442772461be13996b4d4766e81fd8f'
const metadata = {
  name: 'Web3Modal',
  description: 'Web3Modal BSCS',
  url: 'https://web3modal.com', // origin must match your domain & subdomain
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}
const customBsc = {
  ...bsc,
  rpcUrls: {
    ...bsc.rpcUrls,
    default: {
      http: ['https://bsc-dataseed.binance.org/'], // RPC tùy chỉnh
    },
  },
}
const chains = [customBsc, arbitrum, base, avalanche, mainnet, optimism, polygon, fantom, zkSync, opBNB, dogechain, sei] as const
const config = defaultWagmiConfig({
  chains, // required
  projectId, // required
  metadata, // required
  enableInjected: true, // Optional - true by default
  enableWalletConnect: true, // Optional - true by default
  enableEIP6963: true, // Optional - true by default
  enableCoinbase: true, // Optional - true by default
})

function App() {
  const queryClient = new QueryClient()

  createWeb3Modal({
    wagmiConfig: config,
    projectId,
    enableAnalytics: true // Optional - defaults to your Cloud configuration
  })

  const configRain = getDefaultConfig({
    appName: 'BSCStation',
    projectId: '5f6c18132c6e21af2b276b34ad0af7ec',
    chains: [customBsc, arbitrum, base, avalanche, mainnet, optimism, polygon, fantom, zkSync, opBNB, dogechain, sei],
    ssr: true,
  });

  const Disclaimer: DisclaimerComponent = ({ Text, Link }) => (
    <Text>
      Bys connecting your wallet, you agree to the{' '}
      <Link href="https://www.bscs.finance/TermOfUse">Terms of use</Link> and
      acknowledge you have read and understand the protocol{' '}
      <Link href="https://docs.bscs.finance/">Documentation</Link>
    </Text>
  );


  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider
          appInfo={{
            appName: 'BSCStation',
            disclaimer: Disclaimer,
          }}
          theme={darkTheme({
            accentColor: '#7b3fe4',
            accentColorForeground: 'white',
            borderRadius: 'medium',
            fontStack: 'system',
            overlayBlur: 'small',
          })}>
          <AppClass>
            <Main>
              <Routes>
                <Route path={HOME} element={<Home />} />
                <Route path={APPLY} element={<ApplyLaunch />} />
                <Route path={ICUBATOR} element={<IncubatorPage />} />
                <Route path={LAUNCHPOOL_URL} element={<LaunchPoolNew />} />
                <Route path={LAUNCHPOOL_DETAIL_URL} element={<StakePoolV2 />} />
                <Route path="*" element={<Navigate to={HOME} replace />} />
              </Routes>
            </Main>
          </AppClass>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;

const AppClass = styled.section`
  text-align: center;
//   overflow: hidden;
  font-family: Poppins;
  background: #fff;
`;

